export default {"src":"/_next/static/media/logistic-shipping-company.074811e3.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};